import { render, staticRenderFns } from "./grantaccess.vue?vue&type=template&id=0e3c06d9&"
import script from "./grantaccess.vue?vue&type=script&lang=js&"
export * from "./grantaccess.vue?vue&type=script&lang=js&"
import style0 from "./grantaccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports